import ObjectTools from 'utils/objects/objectTools'

const generalConfig = {
  chart: {
    type: 'line',
    style: {
      fontFamily: '\'Open Sans\', Helvetica, Arial, sans-serif'
    },
    marginBottom: 60,
    backgroundColor: 'rgba(0,0,0,0)',
    events: {
      load() {
        if (this.renderer.forExport) {
          console.log("exporting");
          this.yAxis[0].update({
            labels: {
              style: {
                fontSize: '4px'
              }
            },
            title: {
              style: {
                fontSize: '4px'
              }
            }
          });
          this.xAxis[0].update({
            labels: {
              style: {
                fontSize: '4px'
              },
              formatter: function() {
                return this.value.substring(0, 2);
              }
            }
          })
        }
      }
    }
  },
  credits: {
    enabled: true,
    text: '',
    href: 'https://www.orkestra.deusto.es',
    position: {
      y: -5
    },
    style: {
      fontSize: '9px'
    }
  },
  exporting: {
    enabled: true,
    // url: "http://localhost:7801",
    sourceWidth: 450,
    sourceHeight: 375,
    buttons: {
      contextButton: {
        enabled: false
      }
    },
    chartOptions: {
      plotOptions: {
      }
    }
  },
  title: {
    text: ''
  },

  subtitle: {
    text: ''
  },
  xAxis: {
    allowDecimals: false,
    title: {
      style: {
        fontSize: "12px"
      }
    },
    labels: {
      style: {
        fontSize: "12px",
        color: "#000000"
      }
    },
    lineWidth: 0.75,
    lineColor: "#000000",
    tickLength: 0,
    gridLineColor: "#b3b3b3"
  },
  yAxis: {
    title: {
      text: '',
      style: {
        fontSize: "12px",
        color: "#000000"
      }
    },
    labels: {
      style: {
        fontSize: "12px",
        color: "#000000"
      }
    }
  },
  tooltip: {
    valueSuffix: ''
  },

  legend: {
    enabled: true,
    layout: 'horizontal',
    align: 'right',
    verticalAlign: 'top',
    y: -30,
    itemStyle: {
      fontWeight: 'normal',
      fontSize: '12px'
    },
    symbolWidth: 30
  },
  plotOptions: {
    series: {
      marker: {
        enabled: false,
        symbol: 'circle'
      },
      label: {
        enabled: false
      }
    }
  },
  series: []
};

let selectedRegionConfig = ObjectTools.copyObject(generalConfig)
let allRegionsConfig = ObjectTools.copyObject(generalConfig)
let referenceRegionsConfig = ObjectTools.copyObject(generalConfig)
let sameCountryRegionsConfig = ObjectTools.copyObject(generalConfig)
let otherRegionsConfig = ObjectTools.copyObject(generalConfig)

const chartLinesConfig = {
  selectedRegionConfig,
  allRegionsConfig,
  referenceRegionsConfig,
  sameCountryRegionsConfig,
  otherRegionsConfig
}

export default chartLinesConfig;



// WEBPACK FOOTER //
// ./src/modules/Charts/DecoupledLines/DecoupledLinesChart/DecoupledLinesChartConfig.js